<template>
    <v-list-item :to="{ name: 'M_Mazes' }" :disabled="disabled">
        <v-list-item-icon>
            <v-icon>mdi-routes</v-icon>
        </v-list-item-icon>
        
        <v-list-item-content>
            <v-list-item-title>Mazes</v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
export default {
    name: 'mNavItemMazes',
    props: {
        disabled: Boolean,
    }
}
</script>